
import yup from "src/utils/yup/extensionMethods";

const deleteSchema = (translate: Function) => yup.object().shape({
	iqc001Descricao: yup.string()
		.required(translate("Titulo do indicador não confere"))
		.oneOf([yup.ref("iqc001DescricaoConfirmation")], translate("Titulo do indicador não confere"))
});

export default deleteSchema;
